import React from 'react';
import { getCodeStatus } from '../../utils/vendorCodes';

/**
 * The single, shared badge for a vendor's ERP code status.
 *
 * Label and colours come from CODE_STATUS_LABELS in utils/vendorCodes, so every
 * screen that shows code status renders it identically and the views can never
 * drift. This is the one component to reuse — do not re-implement the pill.
 *
 * Deliberately quiet: it sits in a column of monospace codes, so a loud badge on
 * every row would shout over the real data. A small dot plus muted text reads as
 * "here's the code status" without competing with the codes around it.
 */
const CodeStatusPill = ({ vendor, className = '' }) => {
  const { label, dot, text } = getCodeStatus(vendor);
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-sans ${text} ${className}`}
      title={vendor?.code_status_detail || undefined}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      {label}
    </span>
  );
};

export default CodeStatusPill;
